import { render, staticRenderFns } from "./DeliveryOverview.vue?vue&type=template&id=f18c22d8&"
import script from "./DeliveryOverview.vue?vue&type=script&lang=js&"
export * from "./DeliveryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports